module.exports = __webpack_public_path__ + "img/HISTORIA.2700d7de.png";